"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Package Import
 */
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
/*
 * Local Import
 */
const App_1 = __importDefault(require("src/components/App"));
const loadKC_1 = require("src/utils/loadKC");
const loginKC_1 = require("src/utils/loginKC");
// Style
require("@oclock/crumble/dist/css/styles.css");
/*
 * Render
 */
document.addEventListener('DOMContentLoaded', () => {
    (0, loadKC_1.loadKeyCloak)(() => {
        (0, loginKC_1.loginKC)(() => {
            (0, react_dom_1.render)(react_1.default.createElement(App_1.default, null), document.getElementById('root'));
        });
    });
});
